import { render } from "./InterpretationText.vue?vue&type=template&id=2b019ba7&scoped=true"
import script from "./InterpretationText.vue?vue&type=script&lang=js"
export * from "./InterpretationText.vue?vue&type=script&lang=js"

import "./InterpretationText.vue?vue&type=style&index=0&id=2b019ba7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b019ba7"]])

export default __exports__